__turbopack_context__.v({
  "icon": "ArticleType-module-scss-module__xqNu2q__icon",
  "root": "ArticleType-module-scss-module__xqNu2q__root",
});
